import { assertNever } from './errorKind';
var KEYS = {
    approve: {
        timeout: 'ui-czna-authorities.proposalForm.saveAndApprove.approveTimeout',
        retry: 'ui-czna-authorities.proposalForm.saveAndApprove.approveError',
        forbidden: 'ui-czna-authorities.proposalForm.saveAndApprove.approveForbidden',
        unauthenticated: 'ui-czna-authorities.proposalForm.saveAndApprove.approveUnauthenticated',
    },
    reject: {
        timeout: 'ui-czna-authorities.proposalForm.saveAndReject.rejectTimeout',
        retry: 'ui-czna-authorities.proposalForm.saveAndReject.rejectError',
        forbidden: 'ui-czna-authorities.proposalForm.saveAndReject.rejectForbidden',
        unauthenticated: 'ui-czna-authorities.proposalForm.saveAndReject.rejectUnauthenticated',
    },
};
export var ALL_SECOND_LEGS = ['approve', 'reject'];
export var secondLegMessageIdForKind = function (leg, kind) {
    var keys = KEYS[leg];
    switch (kind) {
        case 'forbidden':
            return keys.forbidden;
        case 'unauthenticated':
            return keys.unauthenticated;
        case 'timeout':
            return keys.timeout;
        case 'network':
        case 'conflict':
        case 'notFound':
        case 'validation':
        case 'unprocessable':
        case 'server':
        case 'unknown':
            return keys.retry;
        default:
            return assertNever(kind);
    }
};
